module.exports = __webpack_public_path__ + "static/media/github.56aa79c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/github.png
// module id = 125
// module chunks = 1